document.documentElement.classList.remove('no-js');
(function () {
  'use strict';
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  var root = null;

  /* ---------- Packs ---------- */
  window.GD_SELECTED_IDX = 0;
  function selectPack(o) {
    var list = o.parentNode;
    $$('.dcb-o', list).forEach(function (x) { var on = x === o; x.classList.toggle('dcb-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
    window.GD_SELECTED_IDX = parseInt(o.getAttribute('data-dcb-i'), 10) || 0;
    var q = document.querySelector('[data-gd-qty]'); if (q) q.value = o.getAttribute('data-qty') || (window.GD_SELECTED_IDX + 1);
  }
  function initPacks() {
    $$('[data-dcb] .dcb-o').forEach(function (o) {
      if (o.classList.contains('dcb-on')) selectPack(o);
      o.addEventListener('click', function () { selectPack(o); });
      o.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectPack(o); } });
    });
  }

  /* ---------- Seguimiento de entrega ---------- */
  var DAYS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function fmt(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function addBusiness(d, n) { var r = new Date(d.getTime()); while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; }
  function initTracker() {
    $$('[data-dct]').forEach(function (el) {
      var mn = parseInt(el.getAttribute('data-min'), 10) || 3, mx = parseInt(el.getAttribute('data-max'), 10) || 5;
      var now = new Date(), d3 = new Date(now.getTime()); d3.setDate(d3.getDate() + 2);
      var range = fmt(addBusiness(now, mn)) + ' – ' + fmt(addBusiness(now, mx));
      var pill = (el.getAttribute('data-pill') || '').replace('{min}', mn).replace('{max}', mx).replace('{rango}', range);
      var p = el.querySelector('[data-dct-pill]'); if (p && p.textContent !== pill) p.textContent = pill;
      var a = el.querySelector('[data-dct-d3]'); if (a) a.textContent = fmt(d3);
      var b = el.querySelector('[data-dct-d4]'); if (b) b.textContent = range;
    });
  }

  /* ---------- Reseñas: ver todas ---------- */
  function initReviews() {
    $$('[data-dcr-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = btn.closest('[data-dcr]');
        $$('[data-dcr-extra]', box).forEach(function (c) { c.hidden = false; });
        btn.hidden = true;
      });
    });
  }

  /* ---------- Releasit ---------- */
  var RSI = '._rsi-buy-now-button, [id="rsi_buy_now_button"]';
  function realRsiButton() {
    var list = $$(RSI, root).concat($$(RSI));
    for (var i = 0; i < list.length; i++) { var b = list[i]; if (!b.closest('[data-gd-rsi]') && !b.closest('[data-dcl-sticky]') && !b.closest('#_rsi-buy-now-button-floating')) return b; }
    return null;
  }
  function buyNow() {
    var b = realRsiButton();
    if (b) { syncOffer(); b.click(); return; }
    var f = document.querySelector('[data-dcl-form]'); if (f) f.submit();
  }
  function initReleasit() {
    /* Enlace /rsi-btn-hook que Releasit no convirtió: abrir el formulario igual */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href="/rsi-btn-hook"]');
      if (!a || e.defaultPrevented) return;
      e.preventDefault(); buyNow();
    });
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest(RSI); if (t) syncOffer();
    }, true);
  }
  var RSI_MODAL = '#_rsi-cod-form-modal._rsi-cod-form-modal-open', RSI_OFFER = '._rsi-quantity-offers-offer-container', RSI_SEL = '_rsi-quantity-offers-selected';
  var syncing = false;
  function syncOffer() {
    if (syncing) return; syncing = true;
    var t0 = Date.now(), done = false, obs = null, clicks = 0, last = 0;
    function finish() { done = true; syncing = false; if (obs) { obs.disconnect(); obs = null; } }
    function apply() {
      if (done) return true;
      if (!document.querySelector(RSI_MODAL)) return false;
      var offers = document.querySelectorAll(RSI_OFFER); if (!offers.length) return false;
      var el = offers[window.GD_SELECTED_IDX | 0]; if (!el) { finish(); return true; }
      if (el.classList.contains(RSI_SEL) || el.querySelector('.' + RSI_SEL)) { finish(); return true; }
      var target = el.querySelector('._rsi-quantity-offers-offer') || el;
      if (clicks < 6 && Date.now() - last > 250) { clicks++; last = Date.now(); try { target.click(); } catch (e) {} }
      return false;
    }
    if (apply()) return;
    if (window.MutationObserver) {
      obs = new MutationObserver(function () { if (apply()) return; if (Date.now() - t0 > 6000) finish(); });
      obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    (function poll() { if (done) return; if (apply()) return; if (Date.now() - t0 > 6000) { finish(); return; } setTimeout(poll, 150); })();
  }

  /* ---------- Botón fijo + volver arriba ---------- */
  function initSticky() {
    var st = document.querySelector('[data-dcl-sticky]'), top = document.querySelector('[data-gd-totop]');
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    if (st) {
      var tries = 0;
      (function mount() {
        var real = realRsiButton();
        if (!real) { if (++tries < 40) setTimeout(mount, 250); return; }
        var c = real.cloneNode(true);
        c.removeAttribute('id'); c.setAttribute('data-gd-sticky-btn', '');
        c.style.setProperty('width', '100%', 'important'); c.style.setProperty('margin', '0', 'important');
        st.innerHTML = ''; st.appendChild(c);
        c.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); buyNow(); });
      })();
    }
    var first = document.querySelector('.dcl-inline-cta');
    var ticking = false, lastOn = null, lastTop = null;
    function check() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      var on = first ? first.getBoundingClientRect().bottom < 0 : y > 400;
      if (st && on !== lastOn) { lastOn = on; st.classList.toggle('show', on); document.body.classList.toggle('gd-has-sticky', on); }
      var t = y > 300; if (top && t !== lastTop) { lastTop = t; top.classList.toggle('is-on', t); }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function init() {
    root = document.querySelector('.dcl'); if (!root) return;
    [initPacks, initTracker, initReviews, initReleasit, initSticky].forEach(function (f) { try { f(); } catch (e) { if (window.console) console.warn('gd', e); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
